const reorderPhaseIds = (
  phaseIds: string[],
  sourceId: string,
  targetId: string,
): string[] | null => {
  if (sourceId === targetId) {
    return null;
  }
  const fromIndex = phaseIds.indexOf(sourceId);
  const toIndex = phaseIds.indexOf(targetId);
  if (fromIndex < 0 || toIndex < 0) {
    return null;
  }
  const next = [...phaseIds];
  next.splice(fromIndex, 1);
  next.splice(toIndex, 0, sourceId);
  return next;
};

export default reorderPhaseIds;
